import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";
const DemoCallForSolutionsForm = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-white flex flex-col items-center p-4 pb-12">
      {/* Logo */}
      <div className="mt-12 mb-6">
        <img src="/lovable-uploads/bb3f5ac9-6c4b-494d-9a60-86ee7a3feb77.png" alt="iSPAI Logo" className="h-16 cursor-pointer" onClick={() => navigate("/engage")} />
      </div>

      {/* Title */}
      <h1 className="text-3xl font-bold text-black mb-8 text-center">
        iSPAI Call for Solution (CfS)
      </h1>

      <div className="w-full max-w-4xl">
        {/* Purpose Card */}
        <Card className="mb-8 border border-gray-200">
          <CardContent className="pt-6">
            <h2 className="text-xl font-semibold text-center mb-4">Purpose</h2>
            <p className="text-gray-700 leading-relaxed">This is a CURT demonstration for the iSPAI Call for Solutions (CfS) process. Click through each stage to see examples of the section as it applies to the CURT member role: Curator, Contributor, or Confirmer. The focus is on capturing and structuring ideas—whether in the form of designs, documentation, or refinements to existing materials—rather than producing exhaustive detail. This exercise is a snapshot of thinking at this stage, providing a foundation for further iteration and refinement.</p>
          </CardContent>
        </Card>

        {/* Instructions Card */}
        <Card className="mb-8 border border-gray-200">
          <CardContent className="pt-6">
            <h2 className="text-xl font-semibold text-center mb-4">Instructions</h2>
            
            <div className="space-y-6">
              <div>
                <h3 className="font-semibold">1. Select Your Functional Area</h3>
                <p className="text-gray-700 ml-5 mt-1">Choose the functional domain relevant to your expertise.</p>
              </div>

              <div>
                <h3 className="font-semibold">2. Identify the Curator</h3>
                <p className="text-gray-700 ml-5 mt-1">
                  The Curator leads the effort in this functional area and is responsible for structuring the work.
                </p>
              </div>

              <div>
                <h3 className="font-semibold">3. Add Contributors and the Confirmer</h3>
                <p className="text-gray-700 ml-5 mt-1">
                  The Curator will identify team members who will participate as Contributors (those designing and developing 
                  solutions) and a Confirmer (who will validate and review the outcomes).
                </p>
              </div>

              <div>
                <h3 className="font-semibold">4. Provide Contact Information</h3>
                <p className="text-gray-700 ml-5 mt-1">
                  For each role include a name, email, and phone number.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Next Button */}
        <div className="flex justify-center mt-8">
          <Button className="bg-[#14213d] hover:bg-[#0d1829] text-white px-8 py-2 rounded" onClick={() => navigate("/demo-call-for-solutions/functional-area")}>
            Next: Select Functional Area
          </Button>
        </div>
      </div>
    </div>;
};
export default DemoCallForSolutionsForm;